module.exports = __webpack_public_path__ + "static/media/tagujam_typeface.d1d27ab4.svg";